import './styles.scss'
import I18n from 'lib/i18n'

import React, { Component } from 'react'
import { connect } from 'kea'

import railsContext from 'lib/selectors/rails-context'

@connect({
  props: [railsContext, ['i18nLocale as locale']]
})
export default class GoodFit extends Component {
  render () {
    const { locale, labelClassName, wrapperSpace, noborder, contentStyle = {}, className, mode } = this.props

    return (
      <div className={`widget white ${className} ${wrapperSpace ? 'space' : 'nospace'} ${noborder ? 'noborder' : ''}`}>
        {mode === 'widget' ? (
          <div className='good-fit-widget'>
            <h3 className={`boxtitle line  ${labelClassName || ''}`}>{I18n.t('bookings.good_fit.title')}</h3>
            <div className='padding-no-top2' style={{ fontSize: '13px', color: '#222', ...contentStyle }}>
              <div style={{ textAlign: 'center' }}>
                <div className={`good-fit-image good-fit-image-${locale === 'fr' ? 'fr' : 'en'}`} />
              </div>
              <br />
              {I18n.t('bookings.good_fit.line_1')}
            </div>
          </div>
        ) : (
          <div className='good-fit'>
            <div className='good-fit-img'>
              <div className={`good-fit-image good-fit-image-${locale === 'fr' ? 'fr' : 'en'}`} />
            </div>
            <h4>{I18n.t('bookings.show.guarantee_title')}</h4>
            <ul>
              <li>{I18n.t('bookings.good_fit.line_1')}</li>
              <li>{I18n.t('bookings.show.guarantee_line_2')}</li>
            </ul>
          </div>
        )}
      </div>
    )
  }
}
